(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[442],{

/***/ 10027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-locator",
      function () {
        return __webpack_require__(9532);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52681);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6212);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63372);
/* harmony import */ var _src_components_storeSuggestion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75290);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);










const stores = [
    {
        title: "Signature Company Showrooms - Chennai",
        address: "2nd floor New No.85, Old No.30, Maharaja Tower, Land Mark Ashok Pillar First Avenue , Ashok Nagar, Chennai, Tamil Nadu, 600083",
        contact: "Vishnu Kr",
        phone: "9962511617",
        email: "vishnu.kr@orientbell.com",
        latitude: 13.033595,
        longitude: 80.212185
    },
    {
        title: "Signature Company Showrooms - Dehradun",
        address: "Duggal Complax Nr. Kamla Place Hotel GMS Road, Dehradun, Uttarakhand, 248001",
        contact: "Yashasvi Mijrawat",
        phone: "7428594144",
        email: "yashasvi.mijrawat@orientbell.com",
        latitude: 30.308588,
        longitude: 78.007184
    },
    // TODO : Removed by client on 31-03-2025
    // {
    //   title: "Signature Company Showrooms - Delhi",
    //   address: "M 47, M Block market GK – II Delhi – 48, 110048 Near Canara Bank",
    //   contact: "Nikhil Kumar Gautam",
    //   phone: "8373914460",
    //   latitude: 28.533589,
    //   longitude: 77.242506,
    // },
    {
        title: "Signature Company Showrooms - Kochi",
        address: "Surya Gayatri Building No. 32/8, B3 Puthiya Road, New Junction Opp. Holiday Inn Hotal Ernakulam bypass road, Cochin, Kerala, 682031",
        contact: "Raja Lakshmi",
        phone: "9745768058",
        email: "raja.lakshmi@orientbell.com",
        latitude: 9.992292,
        longitude: 76.315264
    },
    {
        title: "Signature Company Showrooms - Lucknow",
        address: "Orient Bell Tile BoutiqueRajrani Apartment G-1 H. No. 970/71 Sector- B Near Beej Nigam office Badshah Nagar Railway Station Faizabad Road MahanagarLucknowUttar Pradesh9984200500",
        contact: "Chinmoy Ghosh",
        phone: "9984786404",
        email: "chinmoy.ghosh@orientbell.com",
        latitude: 26.8711,
        longitude: 80.964213
    },
    {
        title: "Signature Company Showrooms - Pune",
        address: "Shop No 3 and 4 , A tower vega centre , C.T.S. No. 71o, Final Plot No . 401/1, shankarsheth road, Gultekdi, Pune, Maharashtra, 411037",
        contact: "Arbindo Ghosh",
        phone: "7391072247",
        email: "arbindo.ghosh@orientbell.com",
        latitude: 18.49984,
        longitude: 73.862651
    },
    {
        title: "Signature Company Showrooms - Vadodara",
        address: "78-79, 2nd Floor, Surya Kiran Complex, Beside Banker Heart Institute, Old Padra Road, Vadodara, Gujarat 390007",
        contact: "Tapan Thaker",
        phone: "9727740342",
        email: "tapan.thaker@orientbell.com",
        latitude: 22.292511,
        longitude: 73.164375
    }
];
function Index(param) {
    let { statesData , error  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const [activeTabTop, setActiveTabTop] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("simple-search");
    const [selectedState, setSelectedState] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [cityOptions, setCityOptions] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [selectedCity, setSelectedCity] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [cityFromSimpleSearch, setCityFromSimpleSearch] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [allStores, setAllStores] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [modalIsOpen, setModalIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        name: "",
        phone: ""
    });
    const handleAdvancedSearch = (e)=>{
        e.preventDefault();
        if (!selectedState.trim()) return;
        let formattedState = selectedState.toLowerCase().replace(/\s+/g, "-");
        let formattedCity = selectedCity.trim() ? selectedCity.toLowerCase().replace(/\s+/g, "-") : "";
        if (selectedCity.trim()) {
            router.push("/store-locator/".concat(formattedState, "/").concat(formattedCity));
        } else {
            router.push("/store-locator/".concat(formattedState));
        }
    };
    const handleStateChange = (event)=>{
        const selectedStateValue = event.target.value;
        setSelectedState(selectedStateValue);
        const stateData = statesData.find((item)=>item.state === selectedStateValue);
        setCityOptions(stateData ? stateData.cities : []);
    };
    const handleCityChange = (event)=>{
        setSelectedCity(event.target.value);
    };
    const sendSms = async ()=>{
        if (!modalIsOpen) {
            return;
        }
        if (!formData.name) {
            setFormData({
                ...formData,
                error: "Name number is mandatory"
            });
            return;
        }
        if (!formData.phone) {
            setFormData({
                ...formData,
                error: "Phone number is mandatory"
            });
            return;
        }
        if (!formData.city) {
            setFormData({
                ...formData,
                error: "City number is mandatory"
            });
            return;
        }
        if (formData.phone.length != 10) {
            setFormData({
                ...formData,
                error: "Please enter valid 10 digit mobile number"
            });
            return;
        }
        // setFullpageLoading(true);
        let d1 = modalIsOpen.title;
        let d2 = formData.name;
        let d3 = formData.city;
        let d4 = formData.phone;
        let d5 = formData.message;
        let U1 = formData.name;
        let U2 = modalIsOpen.title;
        let U3 = modalIsOpen.address;
        let U4 = modalIsOpen.phone;
        let obj = {
            d1,
            d2,
            d3,
            d4,
            d5,
            U1,
            U2,
            U3,
            U4,
            userPhone: formData.phone,
            dealerPhone: modalIsOpen.d_phone_no
        };
        const res = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].post */ .Z.post("https://proxy.orientbell.com/send-storelocator-sms", obj);
        if (res.status == 200) {
            // setFullpageLoading(false);
            setModalIsOpen(false);
            setFormData({});
            swal("Thank you for your interest in our tiles. We have shared the requested store's details on your WhatsApp");
        } else {
            // setFullpageLoading(false);
            setModalIsOpen(false);
            setFormData({});
            swal("We are unable to send address on your mobile, please try again after some time");
        }
    };
    const redirectToGoogleMaps = (lat, lng)=>{
        const googleMapsUrl = "https://www.google.com/maps/dir/?api=1&destination=".concat(lat, ",").concat(lng);
        window.open(googleMapsUrl, "_blank");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "With 2000+ tiles stores nationwide, Locate Orientbell Tiles Store or tile shop near you. Discover premium floor tiles and Wide range of designs for walls and bathrooms. Visit our store for expert advice and great deals!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Locate Tiles Store Dealer or Tile Shop Near Me | Orientbell Tiles"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Locate Tiles Store Dealer or Tile Shop Near Me | Orientbell Tiles"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "obl-store-page",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "obl-store-intro-section",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                        href: "/",
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                        href: "/store-locator",
                                        children: "Store Locator"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "obl-store-intro-row",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "obl-store-intro-left",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                children: "Orientbell Tiles Dealers"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store-search-section-inner",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Locate The Nearest Tiles Stores"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "obl-store-tab-section",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "storetabs-menu",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                        className: activeTabTop === "simple-search" ? "tab-item active" : "tab-item",
                                                                        onClick: ()=>setActiveTabTop("simple-search"),
                                                                        children: [
                                                                            " ",
                                                                            "Search City",
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        className: activeTabTop === "advanced-search" ? "tab-item active" : "tab-item",
                                                                        onClick: ()=>setActiveTabTop("advanced-search"),
                                                                        children: "Advanced Search"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "obl-store-tab-data",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: activeTabTop === "simple-search" ? "tab-data-col search-nearme active" : "tab-data-col search-nearme",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_storeSuggestion__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: activeTabTop === "advanced-search" ? "tab-data-col search-location active" : "tab-data-col search-location",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                                                            onSubmit: handleAdvancedSearch,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                                className: "list-unstyled search-location",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                        className: "input-group",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                htmlFor: "OutletState",
                                                                                                children: [
                                                                                                    "State",
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                                                                        children: "*"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                                                                name: "state",
                                                                                                className: "input",
                                                                                                required: true,
                                                                                                id: "OutletState",
                                                                                                value: selectedState,
                                                                                                onChange: handleStateChange,
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                                        value: "",
                                                                                                        children: "Select a state"
                                                                                                    }),
                                                                                                    statesData.map((state)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                                            value: state.state,
                                                                                                            children: state.state
                                                                                                        }, state.state))
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                        className: "input-group",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                                htmlFor: "OutletCity",
                                                                                                children: "City"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                                                                name: "city",
                                                                                                className: "input",
                                                                                                id: "OutletCity",
                                                                                                disabled: !selectedState,
                                                                                                value: selectedCity,
                                                                                                onChange: handleCityChange,
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                                        value: "",
                                                                                                        children: "Select a city"
                                                                                                    }),
                                                                                                    cityOptions.map((city)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                                            value: city,
                                                                                                            children: city
                                                                                                        }, city))
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                        className: "actions",
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                            className: "obl-store-actions-btn",
                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                                                type: "submit",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                                        src: "/search-mobile-icon1.svg",
                                                                                                        alt: "Search"
                                                                                                    }),
                                                                                                    " ",
                                                                                                    "Search"
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "obl-store-intro-right",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/OBL-Sun-Proof-Your-Home-1200x400.avif",
                                                alt: "Dealers Banner"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "store_locator_row signature-store",
                                children: stores.map((store, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "obl_store_locator_col",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: store.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "store_add_row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "store_add_text",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: store.address
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                                    children: [
                                                                        "Contact Person : ",
                                                                        store.contact
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                                    children: [
                                                                        "Phone : ",
                                                                        store.phone
                                                                    ]
                                                                })
                                                            }),
                                                            store.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "mailto:".concat(store.email),
                                                                    children: store.email
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "store_add_icon",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "store-whatsapp-icon",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    onClick: ()=>setModalIsOpen(store),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                        stroke: "green",
                                                                        fill: "green",
                                                                        "stroke-width": "0",
                                                                        viewBox: "0 0 448 512",
                                                                        height: "1em",
                                                                        width: "1em",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                            d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "store-duration-icon",
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>redirectToGoogleMaps(store.latitude, store.longitude),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "/duration.svg",
                                                                    alt: "Duration Icon",
                                                                    "data-clarity-loaded": "1j41qhv"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                show: modalIsOpen,
                className: "pincode-popup-bx",
                onHide: ()=>setModalIsOpen(false),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Dialog */ .Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Header */ .Z.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Title */ .Z.Title, {
                                children: "Send this address on WhatsApp to me"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    sendSms();
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "Name*"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "text",
                                        value: formData.name,
                                        onChange: (e)=>{
                                            setFormData({
                                                ...formData,
                                                name: e.target.value,
                                                error: ""
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "Mobile Number*"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "number",
                                        value: formData.phone,
                                        onChange: (e)=>{
                                            setFormData({
                                                ...formData,
                                                phone: e.target.value,
                                                error: ""
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "City*"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "text",
                                        value: formData.city,
                                        onChange: (e)=>{
                                            setFormData({
                                                ...formData,
                                                city: e.target.value,
                                                error: ""
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        children: "Message"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "text",
                                        value: formData.message,
                                        onChange: (e)=>{
                                            setFormData({
                                                ...formData,
                                                message: e.target.value,
                                                error: ""
                                            });
                                        }
                                    }),
                                    (formData === null || formData === void 0 ? void 0 : formData.error) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "error text-danger",
                                        children: formData === null || formData === void 0 ? void 0 : formData.error
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        variant: "primary",
                                        type: "submit",
                                        onClick: sendSms,
                                        style: {
                                            width: "100%"
                                        },
                                        children: "Submit"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ }),

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86594);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31955);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63372);
// components/AddressAutocomplete.js







const AddressAutocomplete = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [selectedAddress, setSelectedAddress] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [getLocationLoading, setgetLocationLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, seterror] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleSelect = async (address)=>{
        setSelectedAddress(address);
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
            placeId: address.value.place_id
        }, async (results, status)=>{
            if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;
                let city = extractCityFromResults(results[0]);
                const lat = location.lat();
                const lng = location.lng();
                if (!city) {
                    const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(lat, "&lon=").concat(lng, "&format=json"));
                    const address = response.data.address;
                    city = address.state;
                }
                localStorage.removeItem("stateFromAdvancedSearch");
                localStorage.removeItem("cityFromAdvancedSearch");
                localStorage.setItem("cityFromSimpleSearch", city);
                localStorage.setItem("latitude", lat);
                localStorage.setItem("longitude", lng);
                // Redirect to the store locator with city in the URL
                router.push("/store-locator/".concat(city.toLowerCase().replace(/\s+/g, "-")));
                setSelectedAddress("");
            } else {
                console.error("Error fetching geocode data:", status);
            }
        });
    };
    // Extract city name from the address components
    const extractCityFromResults = (result)=>{
        const cityComponent = result.address_components.find((component)=>component.types.includes("locality") || component.types.includes("administrative_area_level_2"));
        return cityComponent ? cityComponent.long_name : "";
    };
    const retrieveGeolocation = async ()=>{
        try {
            const position = await new Promise((resolve, reject)=>{
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                });
            });
            if (!router.asPath.includes("/tiles")) {
                props.setLocationPopop(false);
                props.setleadpopop();
                setgetLocationLoading(false);
            }
            const { latitude , longitude  } = position.coords;
            const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(latitude, "&lon=").concat(longitude, "&format=json"));
            const address = response.data.address;
            if (address && address.postcode) {
                const pincode = address.postcode;
                props.setLocationPopop(false);
                props.setleadpopop();
                localStorage.setItem("pincodeSkip", true);
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode);
                (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                    pincodedetails: pincode
                });
                setgetLocationLoading(false);
                if (router.asPath.includes("/tiles")) {
                    router.reload();
                }
            }
        } catch (error) {
            console.error("Error retrieving location:", error);
            const errorMessage = error.message || "Something went wrong while retrieving your location.";
            swal(errorMessage);
        }
    };
    const extractPincodeFromResults = (result)=>{
        const postalCodeComponent = result.address_components.find((component)=>component.types.includes("postal_code"));
        return postalCodeComponent ? postalCodeComponent.short_name : "";
    };
    const renderSuggestions = (active, suggestions, onSelectSuggestion)=>{
        const filteredSuggestions = suggestions.filter((suggestion)=>{
            const hasPostalCode = suggestion.terms.some((term)=>term.types.includes("postal_code"));
            return hasPostalCode;
        });
        return filteredSuggestions.map((suggestion)=>{
            const isActive = active === suggestion.active;
            const classNames = "suggestion-item ".concat(isActive ? "active" : "");
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classNames,
                onClick: ()=>onSelectSuggestion(suggestion),
                children: suggestion.description
            }, suggestion.placeId);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                apiKey: "AIzaSyBrmlHMs5JUON_ErXHEKk_HSd2UoLN20HQ",
                autocompletionRequest: {
                    componentRestrictions: {
                        country: [
                            "in"
                        ]
                    }
                },
                selectProps: {
                    value: selectedAddress,
                    onChange: handleSelect,
                    placeholder: "Search for your city"
                },
                renderSuggestions: renderSuggestions
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "error text-danger",
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AddressAutocomplete);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 52681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15094);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Breadcrumb = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ol", {
      ...listProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Breadcrumb, {
  Item: _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
}));

/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BreadcrumbItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);

/***/ }),

/***/ 35005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70861);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  as,
  bsPrefix,
  variant = 'primary',
  size,
  active = false,
  disabled = false,
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = (0,_restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__/* .useButtonProps */ .FT)({
    tagName: as,
    disabled,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...buttonProps,
    ...props,
    ref: ref,
    disabled: disabled,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
  });
});
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 66611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createWithBsPrefix; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/camelize.js
var rHyphen = /-(.)/g;
function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js





const pascalCase = str => str[0].toUpperCase() + camelize(str).slice(1);
// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
function createWithBsPrefix(prefix, {
  displayName = pascalCase(prefix),
  Component,
  defaultProps
} = {}) {
  const BsComponent = /*#__PURE__*/react.forwardRef(({
    className,
    bsPrefix,
    as: Tag = Component || 'div',
    ...props
  }, ref) => {
    const componentProps = {
      ...defaultProps,
      ...props
    };
    const resolvedPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, prefix);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
      ref: ref,
      className: classnames_default()(className, resolvedPrefix),
      ...componentProps
    });
  });
  BsComponent.displayName = displayName;
  return BsComponent;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7361,7767,5518,4585,6212,6594,3372,9774,2888,179], function() { return __webpack_exec__(10027); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);